/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedStarterPacks.defs'
export { main as default } from './getSuggestedStarterPacks.defs'
